<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     质检方案列表
  +---------------------------------------------------------------------------------------
-->

<template>
	<div class="qc-scheme header-padding">
		<f-page-header />

		<div class="cased-header-box filter-container">
			<div class="filter-box">
				<span class="filter-item">
					<f-search-input v-model="keyword" @change="search" />
				</span>
			</div>
			<el-button type="success" icon="el-icon-plus" @click="edit(null)">新建方案</el-button>
		</div>

		<div class="a-card" v-loading="loading">
			<!-- <el-scrollbar :native="false"> -->
			<el-card v-for="cased in currentlist" :key="cased.schemeid" class="card-container mt-sm" shadow="hover">
				<div class="flex card-body" role="button" @click="edit(cased.schemeid)">
					<i v-if="!cased.is_default" class="el-icon-close close font-20" @click.stop="deleteOne(cased)"></i>
					<div class="card-item">
						<span class="text-bold font-md">{{ cased.scheme_title }}</span>
						<div class="line bg-primary"></div>
						<div class="frame-box text-muted">
							<span v-for="(item, index) in cased.form" :key="index">{{
								item.title +
								" " +
								(index + 1 != cased.form.length ? "|" : "") +
								" "
							}}</span>
						</div>
					</div>
				</div>
			</el-card>
			<!-- </el-scrollbar> -->
		</div>
		<div v-if="currentlist.length == 0" class="empty">
			<img class="image huger mt-lg" src="@/assets/empty.png" />
			<div class="font-md mb-hg">暂无数据</div>
		</div>
	</div>
</template>

<script>
import { qcSchemeListApi, delSchmeApi } from '@/api/qc/schemeApi'
export default {
	name: 'QcScheme',

	components: {
		QcSchemeSelector: () => import('@/views/qc/components/QcSchemeSelector'),
		QcSchemeImport: () => import('@/views/qc/components/QcSchemeImport')
	},

	data () {
		return {
			keyword: '',
			list: [],
			currentlist: [],
			loading: false
		}
	},

	computed: {},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			this.loading = true
			qcSchemeListApi().then(res => {
				this.loading = false
				if (!res.errno) {
					this.list = res.data.list
					this.search()
				}
			})
		},

		search () {
			this.loading = true
			if (this.keyword) {
				var arr = []
				this.list.forEach(item => {
					if (item.scheme_title.match(this.keyword)) {
						arr.push(item)
					}
				})
				this.currentlist = arr
			} else {
				this.currentlist = Object.assign({}, this.list)
			}
			this.loading = false
		},

		edit (id) {
			this.$router.push({ path: '/qc/schemedetail', query: { id: id } })
		},

		deleteOne (item) {
			this.$confirm(`即将删除 <span class="text-danger">${item.scheme_title}</span> ，是否继续？`, '删除质检方案', {
				type: 'warning',
				dangerouslyUseHTMLString: true
			}).then(() => {
				delSchmeApi({ schemeid: item.schemeid }).then(res => {
					if (!res.errno) {
						// 操作成功处理
						this.$message.success('删除成功！')
						this.fetchData()
					} else {
						this.$message.error(res.message)
					}
				})
			})
		},

		toNew () {
			this.$router.push('/qc/schemedetail')
		}
	}
}
</script>

<style lang="scss" scoped>
.qc-scheme {
	position: relative;
	.cased-header-box {
		width: 1180px;
		display: flex;
		margin: 0px auto;
		padding-bottom: 0px;
		justify-content: space-between;
	}
	.a-card {
		display: flex;
		justify-content: space-between;
		flex-flow: wrap;
		width: 1180px;
		margin: 10px auto;

		.card-container {
			width: 575px;
			padding: 20px 20px;
			background: #fff;
			border-radius: 4px;
			&:hover {
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
				.el-icon-close {
					display: block;
				}
			}
			.card-body {
				position: relative;
				// padding: 20px 20px;
				height: 105px;
				.close {
					position: absolute;
					right: 0px;
					top: 0px;
					color: #999999;
					z-index: 100;
					&:hover {
						color: #07c160;
					}
				}
				.card-item {
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					position: relative;
					.line {
						width: 36px;
						height: 5px;
					}
					.frame-box {
						width: 100%;
						height: 36px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
				}
			}
			.el-icon-close {
				display: none;
			}
		}
	}
	.empty {
		margin: 40px auto;
		width: 200px;
		text-align: center;
	}
}
</style>
